import { useStyletron } from 'baseui';
import { themedUseStyletron } from '../../../theme/customTheme';

export function IconPuffer({ height, width, color }: any) {
    return (
        <svg width={width || '100%'} height={height || '100%'} viewBox="0 0 100 100" x="0px" y="0px"><g>
            <path fill={color} d="M90.5,38V24.3a8,8,0,0,0-8-8H61.7V9.2h-4v7.1H25V9.2H21v7.1H2.7v4H21v5.4H8.2V90.8H37.9V25.7H25V20.3H57.7v5.4H44.8V90.8H74.5V25.7H61.7V20.3H82.5a4,4,0,0,1,4,4V38a8.7,8.7,0,1,0,4,0ZM33.9,86.8H12.2V76.7H33.9Zm0-14.1H12.2V43.8H33.9Zm0-43V39.8H12.2V29.7H33.9ZM70.5,86.8H48.8V76.7H70.5Zm0-14.1H48.8V43.8H70.5Zm0-43V39.8H48.8V29.7H70.5Zm18,21.6a4.7,4.7,0,1,1,4.7-4.7A4.7,4.7,0,0,1,88.6,51.2Z"></path></g></svg>




    );
}



export function GraphicPuffer({ height, width, children }: any) {
    const [css, theme] = themedUseStyletron();

    const colorLight = theme.colors.primary300;
    const colorDark = theme.colors.primary500;
    return (

            <svg viewBox="0 0 100 100" width={width || '100%'} opacity='0.3' height={height || '100%'}>
                <linearGradient x1="-20%" y1="0%" x2="100%" y2="0%" gradientUnits="objectBoundingBox" id="autoId_vertTankvertPipeGrad7">
                    <stop offset="-20%" stopColor={colorDark}></stop>
                    <stop offset="40%" stopColor={colorLight}></stop>
                    <stop offset="100%" stopColor={colorDark}></stop>/&gt;
                </linearGradient>
                <radialGradient cx="0%" cy="10%" r="150%" fx="30%" fy="30%" id="autoId_vertTanktopPipeGrad7">
                    <stop offset="-20%" stopColor={colorDark}></stop>
                    <stop offset=" 0%" stopColor={colorLight}></stop>
                    <stop offset="150%" stopColor={colorDark}></stop>/&gt;
                </radialGradient>
                <radialGradient cx="-10%" cy="-30%" r="120%" fx="-10%" fy="-30%" id="autoId_vertTankbottomPipeGrad7">
                    <stop offset="-200%" stopColor={colorDark}></stop>
                    <stop offset="0%" stopColor={colorLight}></stop>
                    <stop offset="100%" stopColor={colorDark}></stop>/&gt;
                </radialGradient>
                { /*<!-- Body --> */}
                <rect x="3%" y="10%" width="94%" height="80%" className={css({ fill: `url("#autoId_vertTankvertPipeGrad7")` })}>
                  
                </rect>
                {children}
                { /*<!-- Half spheres -->*/}
                <path d="M3,10 A105,90 0 0 1 97,10  Z" className={css({ fill: `url("#autoId_vertTanktopPipeGrad7")` })}></path>
                <path d="M3,90 A105,90 0 0 0 97,90  Z" className={css({ fill: `url("#autoId_vertTankbottomPipeGrad7")` })}></path>
                { /*<!-- Gaskets -->*/}
                <rect x="0%" y="10%" rx="1%" ry="1%" width="100%" height="3%" className={css({fill: `url("#autoId_vertTankvertPipeGrad7")` })}></rect>
                <rect x="0%" y="87%" rx="1%" ry="1%" width="100%" height="3%"className={css({ fill: `url("#autoId_vertTankvertPipeGrad7")` })}></rect>
            </svg>);
}